import React from 'react';
import Paragraph from '../../Common/common/src/paragraph/Paragraph';
import Toast from '../../Common/common/src/toast/Toast';

const ContactoCountries = () => {
    return (
        <>
        <br/>
            <Toast status='info' type="alert">
                <Paragraph
                    className="--roboto"
                >
                    Si no encontrás el country donde vivis por favor comunicate con{' '}
                    nosotros al mail <span className='--light-blue-500 --font-bold'>atencionsocios@lanacion.com.ar</span>{' '}
                    o llamanos al <strong>5199-4700</strong> de Lunes a Viernes de 8{' '}
                    a 20hs.
                </Paragraph>
            </Toast>
        </>
    );
};

export default ContactoCountries;
